import { useContext } from 'react';
import { OnlyUnreadStateContext, OnlyUnreadDispatchContext } from './model';

export const useOnlyUnreadState = () => {
  const context = useContext(OnlyUnreadStateContext);
  if (context === undefined) {
    throw new Error(
      'useOnlyUnreadState должен использоваться с OnlyUnreadProvider'
    );
  }
  return context;
};

export const useOnlyUnreadDispatch = () => {
  const context = useContext(OnlyUnreadDispatchContext);
  if (context === undefined) {
    throw new Error(
      'useOnlyUnreadDispatch должен использоваться с OnlyUnreadProvider'
    );
  }
  return context;
};

export const onlyUnreadUpdater = (prev) => !prev;
